import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import _ from "lodash";
import * as React from "react";

export type LinkType = {
    url: string;
    description: string;
    external: boolean;
};

export const Links = ({ links }: { links: LinkType[] }) => {
    const uniqueLinks = _.uniqBy(links || [], (link) => link.url);
    return (
        <>
            {uniqueLinks?.length && (
                <>
                    <h2 className="w-destination-header font-destination-header m-auto mt-16">
                        Useful links
                    </h2>
                    <div className="h-4" />
                    {uniqueLinks.map((link) => (
                        <div
                            className="article m-auto mb-2 w-10/12 text-center xs:w-9/12 sm:w-8/12 md:w-6/12"
                            key={link.url}
                        >
                            {link.external ? (
                                <OutboundLink
                                    href={link.url}
                                    className="app-href text-sm"
                                >
                                    {link.description}
                                </OutboundLink>
                            ) : (
                                <>
                                    <Link
                                        to={link.url}
                                        className="app-href text-sm"
                                    >
                                        {link.description}
                                    </Link>
                                </>
                            )}
                        </div>
                    ))}
                </>
            )}
        </>
    );
};
